import {Quaternion, Vector3} from 'three';
import {hitTestMatrix4} from 'lib';
import {useARStore} from 'stores';

const placeModel = async () => {
  const state = useARStore.getState();
  if (!state.modelData) {
    return;
  }
  const data = state.modelData.data;
  const transform = state.modelData.transform;
  const newModel = {
    id: Math.random().toString(),
    data,
    transform: {
      position: new Vector3().setFromMatrixPosition(hitTestMatrix4).add(transform?.position ?? new Vector3()),
      quaternion: new Quaternion().setFromRotationMatrix(hitTestMatrix4),
      scale: transform?.scale ?? new Vector3(1, 1, 1),
    },
  };
  state.setModelData(null);
  state.setModelActive({id: newModel.id, justPlaced: true});
  state.setModels([...state.models, newModel]);
};

export default placeModel;
